import React, { useEffect, useState } from "react";
import axios from "axios";
import { HardDrive, Link2, LogOut, Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DriveCard = () => {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try {
      const { data } = await axios.get(`${API}/drive/status`);
      setStatus(data);
    } catch {}
  };

  useEffect(() => {
    load();
    const q = new URLSearchParams(window.location.search);
    if (q.get("drive") === "connected") {
      toast.success("Google Drive conectado: tus vídeos se archivarán en NaturBlur/…");
      q.delete("drive");
      window.history.replaceState({}, "", `${window.location.pathname}${q.toString() ? "?" + q : ""}`);
    } else if (q.get("drive") === "error") {
      toast.error("No se pudo conectar Google Drive. Revisa las credenciales y el URI de redirección.");
      q.delete("drive");
      window.history.replaceState({}, "", `${window.location.pathname}${q.toString() ? "?" + q : ""}`);
    }
  }, []);

  const connect = async () => {
    setBusy(true);
    try {
      const { data } = await axios.get(`${API}/drive/connect`);
      window.location.href = data.authorization_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo iniciar la conexión con Drive.");
      setBusy(false);
    }
  };

  const disconnect = async () => {
    try {
      await axios.post(`${API}/drive/disconnect`);
      toast("Google Drive desconectado.");
      load();
    } catch {}
  };

  if (!status) return null;

  return (
    <div data-testid="drive-card" className="mt-4 rounded-2xl bg-white border border-[#F0E2D2] px-4 py-3 flex flex-wrap items-center gap-3">
      <HardDrive size={16} className={status.connected ? "text-[#2FA45A]" : "text-[#8A7F73]"} />
      {!status.configured ? (
        <p className="flex-1 text-[11.5px] font-semibold text-[#8A7F73]">
          <span className="font-extrabold text-[#241E18]">Google Drive (opcional):</span> configura
          {" "}<code className="bg-[#F7EFE6] px-1 rounded">GOOGLE_CLIENT_ID</code> y
          {" "}<code className="bg-[#F7EFE6] px-1 rounded">GOOGLE_CLIENT_SECRET</code> en el servidor para archivar tus vídeos en tu Drive.
        </p>
      ) : status.connected ? (
        <>
          <p className="flex-1 text-[12px] font-semibold text-[#57503F]">
            <span className="font-extrabold text-[#1E6B3A]">Drive conectado</span>
            {status.email ? ` · ${status.email}` : ""} — originales y exportaciones se archivan en <span className="font-bold">NaturBlur/</span>
          </p>
          <button data-testid="drive-disconnect-btn" onClick={disconnect}
            className="h-8 px-3 rounded-lg border border-[#F0E2D2] text-[11.5px] font-bold text-[#8A7F73] hover:border-[#E4574A] hover:text-[#D93025] transition-all inline-flex items-center gap-1.5">
            <LogOut size={12} /> Desconectar
          </button>
        </>
      ) : (
        <>
          <p className="flex-1 text-[12px] font-semibold text-[#57503F]">
            Archiva tus vídeos automáticamente en <span className="font-extrabold">tu Google Drive</span> (la app solo verá los archivos que ella cree).
          </p>
          <button data-testid="drive-connect-btn" onClick={connect} disabled={busy}
            className="h-9 px-4 rounded-full bg-[#241E18] text-white text-[12px] font-extrabold hover:bg-black disabled:opacity-50 transition-colors inline-flex items-center gap-2">
            {busy ? <Loader2 size={13} className="animate-spin" /> : <Link2 size={13} />} Conectar Google Drive
          </button>
        </>
      )}
    </div>
  );
};

export default DriveCard;
